module.exports = __webpack_public_path__ + "static/media/a-store.afff45d2.svg";